import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {
  resetSelectedMenuItem,
} from "../../features/tableOfContents/TableOfContentsSlice";
import {isNullOrEmpty} from "../../utils/isNullOrEmpty";
import {scrollToTopic} from "./tableOfContents";

export function useTableOfContentsScroll(rootRef) {
  const dispatch = useDispatch();
  const selected = useSelector((state) => state.tableOfContents.selectedItem);

  useEffect(() => {
    if (!rootRef?.current) return;

    const root = rootRef.current;

    if (!isNullOrEmpty(selected)) {
      scrollToTopic(root, selected);
      dispatch(resetSelectedMenuItem());
    }
  }, [selected, rootRef]);
}

